module.exports = __webpack_public_path__ + "img/img27.b67400c5.svg";